import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-delete-project-with-members-modal',
    templateUrl: './delete-project-with-members-modal.component.html',
    styleUrls: ['./delete-project-with-members-modal.component.scss', '../../scss/modal.scss'],
    standalone: false
})
export class DeleteProjectWithMembersModalComponent {

  @ViewChild('deleteProjectWithMembers') deleteProjectWithMembersEl: ElementRef;

  @Output() transferOwnership = new EventEmitter();
  @Output() deleteProject = new EventEmitter();

  onTransferOwnership() {
    this.transferOwnership.emit();
    this.closeModal();
  }

  onDeleteProject() {
    this.deleteProject.emit();
    this.closeModal();
  }

  openModal() {
    jQuery(this.deleteProjectWithMembersEl.nativeElement).modal('show');
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.deleteProjectWithMembersEl.nativeElement).modal('hide');
  }

}
